export default [
  {
    path: '/usuarios',
    name: 'Usuarios',
    meta: { descricao: 'Usuarios' },
    component: () => import('@/pages/usuarios/Usuarios')
  },
]
